import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const carouselBlocks = document.querySelectorAll('.content-box-slider-block');

  if (0 < carouselBlocks.length) {
    carouselBlocks.forEach((block) => {
      const slides = block.querySelectorAll('.swiper-slide');
      const args = {
        slidesPerView: 1,
        loop: false,
        autoHeight: true,

        a11y: {
          prevSlideMessage: _x(
            'Go to previous slide',
            'swiper accessibility',
            'vtx'
          ),
          nextSlideMessage: _x(
            'Go to next slide',
            'swiper accessibility',
            'vtx'
          ),
        },

        navigation: {
          prevEl: block.querySelector('.swiper-button-prev'),
          nextEl: block.querySelector('.swiper-button-next'),
        },
      };

      if (1 < slides.length) {
        args.loop = true;
      }

      new Swiper(block.querySelector('.swiper'), args);
    });
  }
});
